module.exports = __webpack_public_path__ + "img/icon5.c59838b3.png";